<micro-select-combo #sel
              placeholder="Form Field Type"
              [mode]="mode"
              [(id)]="type"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
